import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { getErrorMessage } from '@fdm/utils';
import { displayNames } from '../../equipment-tab.constants';
import { EquipmentDescriptionForm } from '../../models';
import { RICHTEXT_EDITOR_CONFIG } from '../../../../shared/richtext-editor-config';
import { AngularEditorModule, AngularEditorConfig } from '@kolkov/angular-editor';
import { createEditorConfigs } from '../../../../shared/richtext-editor-config-helper';
import { ReportForm } from '../../../../report-form';

@Component({
  selector: 'app-equipment-description',
  imports: [
    // App modules
    CommonModule,
    ReactiveFormsModule,

    // Material modules
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    AngularEditorModule
  ],
  templateUrl: './equipment-description.component.html',
  styleUrl: './equipment-description.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class EquipmentDescriptionComponent {
  public form = input.required<FormGroup<EquipmentDescriptionForm>>();
  public configEN = input.required<AngularEditorConfig>();
  public configRU = input.required<AngularEditorConfig>();
  public configKZ = input.required<AngularEditorConfig>();

  public readonly displayNames = displayNames;

  getErrorMessage(fieldName: string): string | null {
    return getErrorMessage(this.form(), fieldName, this.displayNames);
  }

}
